import { render, staticRenderFns } from "./ImgViewer.vue?vue&type=template&id=1bb03843&scoped=true&"
import script from "./ImgViewer.vue?vue&type=script&lang=js&"
export * from "./ImgViewer.vue?vue&type=script&lang=js&"
import style0 from "./ImgViewer.vue?vue&type=style&index=0&id=1bb03843&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb03843",
  null
  
)

export default component.exports